// extracted by mini-css-extract-plugin
var _1 = "Form-module_form__R12v9o";
var _2 = "Form-module_form_layout_column__OSjUH3";
var _3 = "Form-module_form_layout_grid__F15Vgl";
var _4 = "Form-module_form_layout_row__VyPlMo";
export { _1 as "form", _2 as "form_layout_column", _3 as "form_layout_grid", _4 as "form_layout_row" }
